import React, { useEffect, useState, useContext } from "react";
import { Modal, Form, Row, Col, Button, Spinner } from "react-bootstrap";
import { formatDateYYYY_MM_DD, getCurrentDateTime } from "../../functions/common-functions";
import Swal from "sweetalert2";
import axios from "axios";
import withReactContent from "sweetalert2-react-content";
import { AuthContext } from "../../contexts/AuthContext";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { addEnquiryTender } from "../../services/enquiry-tender-service";
import { getPresignedURL } from "../../functions/upload";
import { ALERT_PARAMS } from "../../utils/constant";
import Validate from "../utils/Validation";
import DragDropRender from "../utils/DragDropRender";

const AddEditEnquiryFromDisposal = (props) => {
    const MySwal = withReactContent(Swal);
    const context = useContext(AuthContext);
    const userDetails = {
        userName: context.userName,
        userId: context.userId,
    };

    const [loading, setLoading] = useState(false);
    const todayDate = getCurrentDateTime("/");

    const [enquiryObj, setEnquiryObj] = useState({
        EnquirySourceNumber: "",
        EnquirySource: "Disposal",
        EnquiryStatus: "Created",
        ItemCode: "",
        ItemDescription: "",
        ItemDetail: "",
        Quantity: "",
        UOM: "",
        GST: "",
        Location: "",
        Division: "",
        ItemType: "",
        LogisticCompany: "",
        ProductClass: "",
        CommodityCodes: "",
        AttachImage: "",
        AttachImageFile: null,
        ShowAttachImage: false,
        AttachDocument1: "",
        AttachDocument1File: null,
        ShowAttachDocument1: false,
        AttachDocument2: "",
        AttachDocument2File: null,
        ShowAttachDocument2: false,
        AttachDocument3: "",
        AttachDocument3File: null,
        ShowAttachDocument3: false,
        Remarks: "",
        DueDate: "",
        InsertedBy: userDetails.userId,
        InsertedByName: userDetails.userName,
        InsertedOn: todayDate,
        ModifiedBy: userDetails.userId,
        ModifiedByName: userDetails.userName,
        ModifiedOn: todayDate
    });

    useEffect(() => {
        if (props.disposalData) {
            setEnquiryObj({
                ...props.disposalData,
                DueDate: props.disposalData.DueDate ? formatDateYYYY_MM_DD(new Date(props.disposalData.DueDate)) : "",
                ShowImageToCustomer: props.disposalData.ShowImageToCustomer || false,
                ShowAttachImage: props.disposalData.ShowAttachImage || false,
                ShowAttachDocument1: props.disposalData.ShowAttachDocument1 || false,
                ShowAttachDocument2: props.disposalData.ShowAttachDocument2 || false,
                ShowAttachDocument3: props.disposalData.ShowAttachDocument3 || false,
            });
        }
    }, [props.disposalData]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        console.log("handlechange",name)

        if (name === "Quantity") {
            const allowedChars = /^[a-zA-Z0-9 ]*$/;
            if (!allowedChars.test(value) || value.length > 50) return;
        }

        if (name === "Remarks") {
            const allowedChars = /^[a-zA-Z0-9 .]*$/;
            if (!allowedChars.test(value) || value.length > 250) return;
        }

        const updates = { [name]: type === "checkbox" ? checked : value };
        if (name === "DueDate" && value !== formatDateYYYY_MM_DD(new Date(props.disposalData?.DueDate))) {
            updates.MailStatus = "Pending";
        }

        setEnquiryObj((prevState) => ({
            ...prevState,
            ...updates
        }));
    };

    const handleDateBlur = (e) => {
        const { value } = e.target;
        const today = formatDateYYYY_MM_DD(new Date());
        if (value && value < today) {
            MySwal.fire({
                text: "Due Date cannot be a past date",
                imageUrl: errorImage,
                customClass: "swal-error",
            });
            setEnquiryObj((prevState) => ({
                ...prevState,
                DueDate: ""
            }));
        }
    };

    const handleChangeStatus = async (files, fieldName) => {
        const newFile = files[0];
        if (!newFile) return;

        const formats = fieldName === "AttachImage" ? "imgFormats" : "allFormats";
        const maxFileSize = 20 * 1024 * 1024;
        const validationError = Validate(newFile, formats, maxFileSize);
        if (validationError) {
            MySwal.fire({
                text: validationError,
                imageUrl: errorImage,
                customClass: "swal-error",
            });
            return;
        }

        setEnquiryObj((prevState) => ({
            ...prevState,
            [fieldName]: newFile.name,
            [`${fieldName}File`]: newFile,
        }));
    };

    const handleDeleteDocument = (fieldName) => {
        setEnquiryObj((prevState) => ({
            ...prevState,
            [fieldName]: "",
            [`${fieldName}File`]: null,
        }));
    };

    const uploadFile = async (signedURL, file) => {
        try {
            if (signedURL && file) {
                await axios.put(signedURL, file, {
                    headers: {
                        'Content-Type': file.type,
                    },
                });
            }
            return "";
        } catch (error) {
            console.error("File upload error:", error);
            return error;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        MySwal.fire({
            text: "Are you sure, do you want to Update Enquiry/Tender?",
            confirmButtonText: "Update",
            title: "Update Enquiry/Tender",
            ...ALERT_PARAMS,
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);

                try {
                    const enquiryNumber = enquiryObj.EnquiryNumber;
                    const todayDate = getCurrentDateTime("/");

                    const hadDueDate = props.disposalData?.DueDate;
                    const hasDueDate = enquiryObj.DueDate;
                    const shouldChangeStatus = !hadDueDate && hasDueDate;

                    let submissionData = {
                        ...enquiryObj,
                        ProductClass: "",
                        CommodityCodes: "",
                        EnquiryStatus: shouldChangeStatus ? "Not Assigned" : enquiryObj.EnquiryStatus,
                        DueDateFlag: enquiryObj.EnquiryStatus === "Live" ? "Active" : "Inactive",
                        ModifiedBy: userDetails.userId,
                        ModifiedByName: userDetails.userName,
                        ModifiedOn: todayDate
                    };

                    const fileFields = [
                        { field: 'AttachImage', fileField: 'AttachImageFile' },
                        { field: 'AttachDocument1', fileField: 'AttachDocument1File' },
                        { field: 'AttachDocument2', fileField: 'AttachDocument2File' },
                        { field: 'AttachDocument3', fileField: 'AttachDocument3File' }
                    ];

                    for (const { field, fileField } of fileFields) {
                        const fileObj = enquiryObj[fileField];
                        if (fileObj && fileObj instanceof File) {
                            try {
                                const filename = fileObj.name;
                                const signedURL = await getPresignedURL(
                                    `EnquiryTender/${enquiryNumber.replace(/\//g, '_')}/${filename}`
                                );
                                if (signedURL) {
                                    const uploadResult = await uploadFile(signedURL, fileObj);
                                    submissionData[`${field}Flag`] = true
                                    if (!uploadResult) {
                                        submissionData[field] = filename;
                                    } else {
                                        submissionData[field] = "";
                                    }
                                }
                            } catch (fileError) {
                                console.error(`Error uploading ${field}:`, fileError);
                                submissionData[field] = "";
                            }
                        } else if (typeof enquiryObj[field] === 'string' && enquiryObj[field]) {
                            submissionData[field] = enquiryObj[field];
                        }
                    }

                    const result = await addEnquiryTender(submissionData);

                    if (result.status) {
                        setLoading(false);
                        MySwal.fire({
                            text: `Enquiry/Tender updated successfully. Enquiry Number: ${enquiryNumber}`,
                            imageUrl: successImage,
                            customClass: "swal-success"
                        });

                        props.onHide();
                        props.setReload(!props.reload);
                    } else {
                        setLoading(false);
                        MySwal.fire({
                            text: result.message,
                            imageUrl: errorImage,
                            customClass: "swal-error"
                        });
                    }
                } catch (error) {
                    setLoading(false);
                    MySwal.fire({
                        text: "Unable to process request",
                        imageUrl: errorImage,
                        customClass: "swal-error"
                    });
                }
            }
        });
    };

    const handleFileDownload = async (fileName, filetype) => {
        try {
            const enquiryNumber = enquiryObj.EnquiryNumber;
            const disposalNumber = enquiryObj.EnquirySourceNumber;
            // Try Enquiry path first (for updated files)

            let filePath = `EnquiryTender/${enquiryNumber.replace(/\//g, '_')}/${fileName}`;
            let downloadURL = await getPresignedURL(filePath);

            if (enquiryObj[`${filetype}Flag`] == false) {
                // If not found, try Disposal path (for original files)
                filePath = `DisposalIntimation/${disposalNumber.replace(/\//g, '_')}/${fileName}`;
                downloadURL = await getPresignedURL(filePath);
            }

            if (downloadURL) {
                window.open(downloadURL, '_blank');
            } else {
                MySwal.fire({
                    text: "Unable to download file",
                    imageUrl: errorImage,
                    customClass: "swal-error"
                });
            }
        } catch (error) {
            console.error("Error downloading file:", error);
            MySwal.fire({
                text: "Error downloading file",
                imageUrl: errorImage,
                customClass: "swal-error"
            });
        }
    };

    return (
        <Modal show={props.show} onHide={props.onHide} size="xl" backdrop="static" centered>
            {loading && <div className="spinner-box"> <Spinner animation="border" className="spinner" /></div>}
            <Modal.Header closeButton>
                <Modal.Title>{props.action} Enquiry/Tender from Disposal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form id="enquirytenderform" name="enquirytenderform" autoComplete="off">
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="EnquirySourceNumber"
                                    type="text"
                                    name="EnquirySourceNumber"
                                    placeholder=" "
                                    value={enquiryObj.EnquirySourceNumber}
                                    readOnly
                                />
                                <Form.Label htmlFor="EnquirySourceNumber">Disposal Number</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="ItemCode"
                                    type="text"
                                    name="ItemCode"
                                    placeholder=" "
                                    value={enquiryObj.ItemCode}
                                    readOnly
                                />
                                <Form.Label htmlFor="ItemCode">Item Code</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="ItemDescription"
                                    type="text"
                                    name="ItemDescription"
                                    placeholder=" "
                                    value={enquiryObj.ItemDescription}
                                    readOnly
                                />
                                <Form.Label htmlFor="ItemDescription">Item Description</Form.Label>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    as="textarea"
                                    rows={1}
                                    id="ItemDetail"
                                    name="ItemDetail"
                                    placeholder=" "
                                    value={enquiryObj.ItemDetail}
                                    readOnly
                                />
                                <Form.Label htmlFor="ItemDetail">Item Detail</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="ItemType"
                                    type="text"
                                    name="ItemType"
                                    placeholder=" "
                                    value={enquiryObj.ItemType}
                                    readOnly
                                />
                                <Form.Label htmlFor="Division">Item Type</Form.Label>
                            </Form.Group>
                        </Col>
                         <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="Division"
                                    type="text"
                                    name="Division"
                                    placeholder=" "
                                    value={enquiryObj.Division}
                                    readOnly
                                />
                                <Form.Label htmlFor="Division">Division</Form.Label>
                            </Form.Group>
                        </Col>                        
                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="Location"
                                    type="text"
                                    name="Location"
                                    placeholder=" "
                                    value={enquiryObj.Location}
                                    readOnly
                                />
                                <Form.Label htmlFor="Location">Location</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="LogisticCompany"
                                    type="text"
                                    name="LogisticCompany"
                                    placeholder=" "
                                    value={enquiryObj.LogisticCompany}
                                    readOnly
                                />
                                <Form.Label htmlFor="LogisticCompany">Logistic Company</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="Quantity"
                                    type="text"
                                    name="Quantity"
                                    placeholder=" "
                                    value={enquiryObj.Quantity}
                                    onChange={handleChange}
                                    readOnly
                                />
                                <Form.Label htmlFor="Quantity">Quantity</Form.Label>
                            </Form.Group>
                        </Col>                        
                    </Row>
                    <Row>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="UOM"
                                    type="text"
                                    name="UOM"
                                    placeholder=" "
                                    value={enquiryObj.UOM}
                                    onChange={handleChange}
                                    readOnly
                                />
                                <Form.Label htmlFor="UOM">UOM</Form.Label>
                            </Form.Group>
                        </Col>
                         <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="GST"
                                    type="text"
                                    name="GST"
                                    placeholder=" "
                                    value={enquiryObj.GST}
                                    readOnly
                                />
                                <Form.Label htmlFor="GST">GST%</Form.Label>
                            </Form.Group>
                        </Col>
                        <Col lg={4} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    id="DueDate"
                                    type="date"
                                    name="DueDate"
                                    placeholder=" "
                                    value={enquiryObj.DueDate}
                                    onChange={handleChange}
                                    onBlur={handleDateBlur}
                                    min={formatDateYYYY_MM_DD(new Date())}
                                    disabled={props.action === "View"}
                                />
                                <Form.Label htmlFor="DueDate">Due Date</Form.Label>
                            </Form.Group>
                        </Col>                       
                    </Row>
                    <Row>
                        
                        <Col lg={8} xs={12}>
                            <Form.Group className="g-input">
                                <Form.Control
                                    as="textarea"
                                    rows={1}
                                    id="Remarks"
                                    name="Remarks"
                                    placeholder=" "
                                    value={enquiryObj.Remarks}
                                    onChange={handleChange}
                                    readOnly={props.action === "View"}
                                />
                                <Form.Label htmlFor="Remarks">Remarks</Form.Label>
                            </Form.Group>
                        </Col>
                        {/* <Col lg={4} xs={12}>
                            <Form.Group>
                                <Form.Check
                                    type="checkbox"
                                    id="ShowImageToCustomer"
                                    name="ShowImageToCustomer"
                                    label="Show Image to Customer"
                                    checked={enquiryObj.ShowImageToCustomer}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col> */}
                    </Row>
                    {/* <Row>
                        <Col lg={12} xs={12} style={{ marginTop: '-10px' }}>
                            <Form.Label className="SubHeaderProjectDetails">Images Attachment</Form.Label>
                            <DragDropRender
                                supportedFilesLabel="Supports: JPEG, JPG, PNG, Max File Size – up to 20MB per file"
                                val={enquiryObj.ImagesAttachment}
                                handleChangeEvent={(params) => handleChangeStatus(params, 'ImagesAttachment')}
                                handleDeleteDocEvent={() => handleDeleteDocument('ImagesAttachment')}
                                handleDownloadDocEvent={(fileName) => handleFileDownload(fileName)}
                                action="Edit"
                            />
                        </Col>
                    </Row> */}
                    <Row>
                        <Col lg={6} xs={12}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Form.Label className="SubHeaderProjectDetails" style={{ marginBottom: 0 }}>Attach Image</Form.Label>
                                <Form.Check
                                    type="checkbox"
                                    id="ShowAttachImage"
                                    name="ShowAttachImage"
                                    label="Show to Customer"
                                    checked={enquiryObj.ShowAttachImage}
                                    onChange={handleChange}
                                    disabled={props.action === "View"}
                                />
                            </div>
                            <DragDropRender
                                supportedFilesLabel="Supports: Image formats (JPEG, JPG, PNG), Max File Size – up to 20MB per file"
                                val={enquiryObj.AttachImage}
                                handleChangeEvent={(params) => handleChangeStatus(params, 'AttachImage')}
                                handleDeleteDocEvent={() => handleDeleteDocument('AttachImage')}
                                handleDownloadDocEvent={(fileName) => handleFileDownload(fileName, 'AttachImage')}
                                action="Edit"
                                disabled={props.action === "View"}
                            />
                        </Col>
                        <Col lg={6} xs={12}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Form.Label className="SubHeaderProjectDetails" style={{ marginBottom: 0 }}>Attach Document 1</Form.Label>
                                <Form.Check
                                    type="checkbox"
                                    id="ShowAttachDocument1"
                                    name="ShowAttachDocument1"
                                    label="Show to Customer"
                                    checked={enquiryObj.ShowAttachDocument1}
                                    onChange={handleChange}
                                    disabled={props.action === "View"}
                                />
                            </div>
                            <DragDropRender
                                supportedFilesLabel="Supports: PDF, DOC/DOCX, XLS/XLSX, JPEG, JPG, MSG, PNG, ZIP, Email Attachments formats, Max File Size – up to 20MB per file"
                                val={enquiryObj.AttachDocument1}
                                handleChangeEvent={(params) => handleChangeStatus(params, 'AttachDocument1')}
                                handleDeleteDocEvent={() => handleDeleteDocument('AttachDocument1')}
                                handleDownloadDocEvent={(fileName) => handleFileDownload(fileName, 'AttachDocument1')}
                                action="Edit"
                                disabled={props.action === "View"}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} xs={12}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Form.Label className="SubHeaderProjectDetails" style={{ marginBottom: 0 }}>Attach Document 2</Form.Label>
                                <Form.Check
                                    type="checkbox"
                                    id="ShowAttachDocument2"
                                    name="ShowAttachDocument2"
                                    label="Show to Customer"
                                    checked={enquiryObj.ShowAttachDocument2}
                                    onChange={handleChange}
                                    disabled={props.action === "View"}
                                />
                            </div>
                            <DragDropRender
                                supportedFilesLabel="Supports: PDF, DOC/DOCX, XLS/XLSX, JPEG, JPG, MSG, PNG, ZIP, Email Attachments formats, Max File Size – up to 20MB per file"
                                val={enquiryObj.AttachDocument2}
                                handleChangeEvent={(params) => handleChangeStatus(params, 'AttachDocument2')}
                                handleDeleteDocEvent={() => handleDeleteDocument('AttachDocument2')}
                                handleDownloadDocEvent={(fileName) => handleFileDownload(fileName, 'AttachDocument2')}
                                action="Edit"
                                disabled={props.action === "View"}
                            />
                        </Col>
                        <Col lg={6} xs={12}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Form.Label className="SubHeaderProjectDetails" style={{ marginBottom: 0 }}>Attach Document 3</Form.Label>
                                <Form.Check
                                    type="checkbox"
                                    id="ShowAttachDocument3"
                                    name="ShowAttachDocument3"
                                    label="Show to Customer"
                                    checked={enquiryObj.ShowAttachDocument3}
                                    onChange={handleChange}
                                    disabled={props.action === "View"}
                                />
                            </div>
                            <DragDropRender
                                supportedFilesLabel="Supports: PDF, DOC/DOCX, XLS/XLSX, JPEG, JPG, MSG, PNG, ZIP, Email Attachments formats, Max File Size – up to 20MB per file"
                                val={enquiryObj.AttachDocument3}
                                handleChangeEvent={(params) => handleChangeStatus(params, 'AttachDocument3')}
                                handleDeleteDocEvent={() => handleDeleteDocument('AttachDocument3')}
                                handleDownloadDocEvent={(fileName) => handleFileDownload(fileName, 'AttachDocument3')}
                                action="Edit"
                                disabled={props.action === "View"}
                            />
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            {
                props.action === "View" ?
                    <></> :
                    <Modal.Footer>
                        <Button className="semiBoldToggleButton cancelBtn" variant="outline-success" onClick={props.onHide}>Cancel</Button>
                        <Button
                            variant="success"
                            className="btn-add-color semiBoldToggleButton"
                            onClick={handleSubmit}
                        >
                            Update
                        </Button>
                    </Modal.Footer>
            }
        </Modal>
    );
};

export default AddEditEnquiryFromDisposal;
